import React from "react";
import { ConfigContext } from "../../Config/ConfigContext";
import { useContext } from "react";
import http from "../../utils/http";
import { parseJwt } from "../../utils/jwt";
import {Box} from "@mui/material";
import auth from "../../utils/auth";
import MicrosoftOAuthProvider from ".";
import MicrosoftLogin from "./MicrosoftLogin";

export default function MicrosoftOAuthChoice(props) {
    //const [authSucceeded, setAuthSucceeded] = useState(false);
    const {config} = useContext(ConfigContext);
    
    return (
        <MicrosoftOAuthProvider 
            clientId={config.microsoftOAuth.clientId}
        >
            <Box sx={{
            }}>
                <MicrosoftLogin
                    ux_mode="redirect"
                    onSuccess={async (msalResponse) => {
                        const bearerTokenObject = parseJwt(auth.getBearerToken());
                        let tenantId = bearerTokenObject.tenantId;
                        let initURL = `${config.uri.base}/auth/init`;
                        if (tenantId) initURL += `&tenantId=${tenantId}`;
                        const bearerToken = await http.get({
                            oauthResponse: JSON.stringify(msalResponse),
                            signInPlatform: 'microsoft',
                            signInToken: msalResponse.idToken,
                        }, initURL, { withCredentials: true });
                        auth.setBearerToken(bearerToken);
                        //setAuthSucceeded(true);
                        props.setAuthSuccess(true);
                    }}
                />
            </Box>
        </MicrosoftOAuthProvider>
    );
}
